import { formatGridCellValue } from '../../../grid-cell-formatters';
import { formatDateValue } from './columnUtils';
import type { GridDateTimeMode } from '../../../utils/dateFormatters';

type FormatGridCellDisplayValueOptions = {
  value: unknown;
  lookupMap?: Record<string, string>;
  dataType?: string;
  format?: string;
  dateTimeMode?: GridDateTimeMode;
};

export const formatGridCellDisplayValue = ({
  value,
  lookupMap,
  dataType,
  format,
  dateTimeMode,
}: FormatGridCellDisplayValueOptions): string => {
  if (value === null || value === undefined) return '-';

  const stringValue = String(value);

  if (lookupMap) {
    return lookupMap[stringValue] ?? '';
  }

  const normalizedDataType = dataType?.toLowerCase();
  const configuredValue =
    normalizedDataType === 'datetime' && dateTimeMode
      ? null
      : formatGridCellValue({ value, dataType: normalizedDataType, format });
  if (configuredValue !== null) return configuredValue;

  return normalizedDataType === 'date' || normalizedDataType === 'datetime'
    ? formatDateValue(
        value,
        normalizedDataType === 'datetime' ? dateTimeMode : undefined,
        normalizedDataType === 'datetime'
      )
    : stringValue;
};
